export default "__VITE_ASSET__OHF9XfIZ__"